"use client";

import { useEffect, useState } from "react";

import { CoverUpload } from "@/components/fileCoverInput/inputMethods/coverUpload/CoverUpload";
import { AudioRecorderUser } from "@/components/fileCoverInput/inputMethods/fileUpload/AudioRecorderUser";
import { FileUpload } from "@/components/fileCoverInput/inputMethods/fileUpload/FileUpload";
import { InvalidLengthMaxModal } from "@/components/fileCoverInput/inputMethods/InvalidLengthMaxModal";
import { InvalidLengthSubscriptionModal } from "@/components/InvalidLengthSubscriptionModal";
import { getUserCountryCode } from "@/data/auth/queries/getUserCountryCode";
import { AudioInputState, UserNoDates } from "@/types/types";

export function InputMethods({
  user,
  checkSubscription,
  audioContext,
  audioLengthMinLimitMinutes,
  audioLengthMaxLimitMinutes,
  showRecorder,
  adjustAcoustic,
  showSelectCoverText,
  showCover,
  setInputFiles,
  setInputCover,
  currentAudioLengthS,
  multipleFiles,
  maxMultiAudioLengthMinutes,
}: {
  user: UserNoDates | null;
  checkSubscription: boolean;
  audioContext: AudioContext | null;
  audioLengthMinLimitMinutes: number | null;
  audioLengthMaxLimitMinutes: number;
  showRecorder: boolean;
  adjustAcoustic: boolean | null;
  showSelectCoverText: boolean | null;
  showCover: boolean;
  setInputFiles: AudioInputState["setInputFile"][];
  setInputCover: AudioInputState["setInputCover"] | null;
  currentAudioLengthS: number;
  multipleFiles: boolean;
  maxMultiAudioLengthMinutes: number | null;
}) {
  const [
    invalidLengthSubscriptionModalOpen,
    setInvalidLengthSubscriptionModalOpen,
  ] = useState(false);
  const [invalidLengthMaxModalOpen, setInvalidLengthMaxModalOpen] =
    useState(false);

  const [showCoverDespiteCountry, setShowCoverDespiteCountry] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const userCountryCode = await getUserCountryCode();

      if (userCountryCode !== null && userCountryCode === "IN") {
        setShowCoverDespiteCountry(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {checkSubscription && (
        <InvalidLengthSubscriptionModal
          open={invalidLengthSubscriptionModalOpen}
          closeModal={() => setInvalidLengthSubscriptionModalOpen(false)}
          user={user}
        />
      )}
      <InvalidLengthMaxModal
        open={invalidLengthMaxModalOpen}
        closeModal={() => setInvalidLengthMaxModalOpen(false)}
        audioLengthMinLimitMinutes={audioLengthMinLimitMinutes}
        audioLengthMaxLimitMinutes={audioLengthMaxLimitMinutes}
      />

      {showCover && setInputCover !== null && showCoverDespiteCountry && (
        <CoverUpload
          className="mb-4"
          adjustAcoustic={adjustAcoustic}
          showSelectCoverText={showSelectCoverText}
          user={user}
          checkSubscription={checkSubscription}
          setInvalidLengthSubscriptionModalOpen={
            setInvalidLengthSubscriptionModalOpen
          }
          audioLengthMinLimitMinutes={audioLengthMinLimitMinutes}
          audioLengthMaxLimitMinutes={audioLengthMaxLimitMinutes}
          setInvalidLengthMaxModalOpen={setInvalidLengthMaxModalOpen}
          showCover={showCover}
          setInputCover={setInputCover}
        />
      )}

      <div
        className="flex items-stretch gap-x-4"
        data-tutorial="conversion-input"
      >
        <FileUpload
          audioContext={audioContext}
          audioLengthMinLimitMinutes={audioLengthMinLimitMinutes}
          audioLengthMaxLimitMinutes={audioLengthMaxLimitMinutes}
          user={user}
          checkSubscription={checkSubscription}
          setInvalidLengthSubscriptionModalOpen={
            setInvalidLengthSubscriptionModalOpen
          }
          setInputFiles={setInputFiles}
          currentAudioLengthS={currentAudioLengthS}
          multipleFiles={multipleFiles}
          maxMultiAudioLengthMinutes={maxMultiAudioLengthMinutes}
          className="w-2/3 flex-grow"
        />
        {showRecorder && (
          <AudioRecorderUser
            audioLengthMinLimitMinutes={audioLengthMinLimitMinutes}
            audioLengthMaxLimitMinutes={audioLengthMaxLimitMinutes}
            checkSubscription={checkSubscription}
            setInvalidLengthSubscriptionModalOpen={
              setInvalidLengthSubscriptionModalOpen
            }
            user={user}
            setInputFiles={setInputFiles}
            currentAudioLengthS={currentAudioLengthS}
            className="w-1/3 flex-grow"
          />
        )}
      </div>
    </>
  );
}
